var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Ordercontent" }, [
    _c(
      "div",
      { staticClass: "list" },
      [
        _vm._l(_vm.couponList, function(item, index) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.couponList.length > 0,
                  expression: "couponList.length>0"
                }
              ],
              staticClass: "couponList van-hairline--surround"
            },
            [
              _c("img", { attrs: { src: require("./images/j2.png") } }),
              _vm._v(" "),
              _c("p", { staticClass: "title" }, [
                _vm._v("奖品：" + _vm._s(item.drawName))
              ])
            ]
          )
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.couponList.length > 0,
                expression: "couponList.length>0"
              }
            ],
            staticClass: "info"
          },
          [_vm._v("有效期：永久")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.couponList.length < 1,
                expression: "couponList.length<1"
              }
            ],
            staticClass: "null"
          },
          [_c("p", [_vm._v("暂无优惠券")])]
        )
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          margin: "16px",
          position: "absolute",
          bottom: "30px",
          left: "50px",
          right: "50px"
        }
      },
      [
        _c(
          "van-button",
          {
            staticClass: "cjBtn",
            attrs: {
              round: "",
              block: "",
              color: "linear-gradient(to right, #ff6034, #ee0a24)"
            },
            on: { click: _vm.choujiang }
          },
          [_vm._v("\n\t\t\t前往抽奖\n\t\t")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-295e3e41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-295e3e41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/choujiang/list.vue
// module id = null
// module chunks = 